import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../../../form/formUtilities';

export const createInitialForm = tsunami => fromJS({
  id: normalizeInitialFormValues(tsunami, ['id']),
  year: normalizeInitialFormValues(tsunami, ['year']),
  month: normalizeInitialFormValues(tsunami, ['month']),
  day: normalizeInitialFormValues(tsunami, ['day']),
  hour: normalizeInitialFormValues(tsunami, ['hour']),
  minute: normalizeInitialFormValues(tsunami, ['minute']),
  second: normalizeInitialFormValues(tsunami, ['second']),
  latitude: normalizeInitialFormValues(tsunami, ['latitude']),
  longitude: normalizeInitialFormValues(tsunami, ['longitude']),
  locationName: normalizeInitialFormValues(tsunami, ['locationName']),
  area: normalizeInitialFormValues(tsunami, ['area']),
  country: normalizeInitialFormValues(tsunami, ['country']),
  regionCode: normalizeInitialFormValues(tsunami, ['regionCode']),
  causeCode: normalizeInitialFormValues(tsunami, ['causeCode']),
  eventValidity: normalizeInitialFormValues(tsunami, ['eventValidity']),
  maxWaterHeight: normalizeInitialFormValues(tsunami, ['maxWaterHeight']),
  tsMtAbe: normalizeInitialFormValues(tsunami, ['tsMtAbe']),
  tsMtIi: normalizeInitialFormValues(tsunami, ['tsMtIi']),
  tsIntensity: normalizeInitialFormValues(tsunami, ['tsIntensity']),
  damageMillionsDollars: normalizeInitialFormValues(tsunami, ['damageMillionsDollars']),
  damageAmountOrder: normalizeInitialFormValues(tsunami, ['damageAmountOrder']),
  housesDestroyed: normalizeInitialFormValues(tsunami, ['housesDestroyed']),
  housesDestroyedAmountOrder: normalizeInitialFormValues(tsunami, ['housesDestroyedAmountOrder']),
  deaths: normalizeInitialFormValues(tsunami, ['deaths']),
  deathsAmountOrder: normalizeInitialFormValues(tsunami, ['deathsAmountOrder']),
  injuries: normalizeInitialFormValues(tsunami, ['injuries']),
  injuriesAmountOrder: normalizeInitialFormValues(tsunami, ['injuriesAmountOrder']),
  warningStatusId: normalizeInitialFormValues(tsunami, ['warningStatusId']),
  comments: normalizeInitialFormValues(tsunami, ['comments']),
  damageMillionsDollarsTotal: normalizeInitialFormValues(tsunami, ['damageMillionsDollarsTotal']),
  damageAmountOrderTotal: normalizeInitialFormValues(tsunami, ['damageAmountOrderTotal']),
  housesDestroyedTotal: normalizeInitialFormValues(tsunami, ['housesDestroyedTotal']),
  housesDestroyedAmountOrderTotal: normalizeInitialFormValues(tsunami, ['housesDestroyedAmountOrderTotal']),
  deathsTotal: normalizeInitialFormValues(tsunami, ['deathsTotal']),
  deathsAmountOrderTotal: normalizeInitialFormValues(tsunami, ['deathsAmountOrderTotal']),
  injuriesTotal: normalizeInitialFormValues(tsunami, ['injuriesTotal']),
  injuriesAmountOrderTotal: normalizeInitialFormValues(tsunami, ['injuriesAmountOrderTotal']),
  missing: normalizeInitialFormValues(tsunami, ['missing']),
  missingAmountOrder: normalizeInitialFormValues(tsunami, ['missingAmountOrder']),
  missingTotal: normalizeInitialFormValues(tsunami, ['missingTotal']),
  missingAmountOrderTotal: normalizeInitialFormValues(tsunami, ['missingAmountOrderTotal']),
  flagLocTimeChk: normalizeInitialFormValues(tsunami, ['flagLocTimeChk'], false),
  flagEffectsChk: normalizeInitialFormValues(tsunami, ['flagEffectsChk'], false),
  flagMaxRunupChk: normalizeInitialFormValues(tsunami, ['flagMaxRunupChk'], false),
  flagAllRunupsEnteredChk: normalizeInitialFormValues(tsunami, ['flagAllRunupsEnteredChk'], false),
  flagAllRunupsSocioChk: normalizeInitialFormValues(tsunami, ['flagAllRunupsSocioChk'], false),
  housesDamaged: normalizeInitialFormValues(tsunami, ['housesDamaged']),
  housesDamagedAmountOrder: normalizeInitialFormValues(tsunami, ['housesDamagedAmountOrder']),
  housesDamagedTotal: normalizeInitialFormValues(tsunami, ['housesDamagedTotal']),
  housesDamagedAmountOrderTotal: normalizeInitialFormValues(tsunami, ['housesDamagedAmountOrderTotal']),
  eqDepth: normalizeInitialFormValues(tsunami, ['eqDepth']),
  eqMagUnk: normalizeInitialFormValues(tsunami, ['eqMagUnk']),
  eqMagMb: normalizeInitialFormValues(tsunami, ['eqMagMb']),
  eqMagMs: normalizeInitialFormValues(tsunami, ['eqMagMs']),
  eqMagMw: normalizeInitialFormValues(tsunami, ['eqMagMw']),
  eqMagMl: normalizeInitialFormValues(tsunami, ['eqMagMl']),
  eqMagMfa: normalizeInitialFormValues(tsunami, ['eqMagMfa']),
  earthquakeEventId: normalizeInitialFormValues(tsunami, ['earthquakeEventId']),
  volcanoEventId: normalizeInitialFormValues(tsunami, ['volcanoEventId']),
  referenceIds: tsunami && tsunami.get('referenceIds') ? tsunami.get('referenceIds').map(v => `${v}`) : [],
  publish: normalizeInitialFormValues(tsunami, ['publish'], true),
  oceanicTsunami: normalizeInitialFormValues(tsunami, ['oceanicTsunami'], true),
});

export const tsunamiEventEditModel = fromJS({
  name: 'tsunamiEventEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  year: fieldToNumber(form.get('year')),
  month: fieldToNumber(form.get('month')),
  day: fieldToNumber(form.get('day')),
  hour: fieldToNumber(form.get('hour')),
  minute: fieldToNumber(form.get('minute')),
  second: fieldToNumber(form.get('second')),
  latitude: fieldToNumber(form.get('latitude')),
  longitude: fieldToNumber(form.get('longitude')),
  locationName: fieldTrimmed(form.get('locationName')),
  area: fieldTrimmed(form.get('area')),
  country: fieldTrimmed(form.get('country')),
  regionCode: fieldToNumber(form.get('regionCode')),
  causeCode: fieldToNumber(form.get('causeCode')),
  eventValidity: fieldToNumber(form.get('eventValidity')),
  maxWaterHeight: fieldToNumber(form.get('maxWaterHeight')),
  tsMtAbe: fieldToNumber(form.get('tsMtAbe')),
  tsMtIi: fieldToNumber(form.get('tsMtIi')),
  tsIntensity: fieldToNumber(form.get('tsIntensity')),
  damageMillionsDollars: fieldToNumber(form.get('damageMillionsDollars')),
  damageAmountOrder: fieldToNumber(form.get('damageAmountOrder')),
  housesDestroyed: fieldToNumber(form.get('housesDestroyed')),
  housesDestroyedAmountOrder: fieldToNumber(form.get('housesDestroyedAmountOrder')),
  deaths: fieldToNumber(form.get('deaths')),
  deathsAmountOrder: fieldToNumber(form.get('deathsAmountOrder')),
  injuries: fieldToNumber(form.get('injuries')),
  injuriesAmountOrder: fieldToNumber(form.get('injuriesAmountOrder')),
  warningStatusId: fieldToNumber(form.get('warningStatusId')),
  comments: fieldTrimmed(form.get('comments')),
  damageMillionsDollarsTotal: fieldToNumber(form.get('damageMillionsDollarsTotal')),
  damageAmountOrderTotal: fieldToNumber(form.get('damageAmountOrderTotal')),
  housesDestroyedTotal: fieldToNumber(form.get('housesDestroyedTotal')),
  housesDestroyedAmountOrderTotal: fieldToNumber(form.get('housesDestroyedAmountOrderTotal')),
  deathsTotal: fieldToNumber(form.get('deathsTotal')),
  deathsAmountOrderTotal: fieldToNumber(form.get('deathsAmountOrderTotal')),
  injuriesTotal: fieldToNumber(form.get('injuriesTotal')),
  injuriesAmountOrderTotal: fieldToNumber(form.get('injuriesAmountOrderTotal')),
  missing: fieldToNumber(form.get('missing')),
  missingAmountOrder: fieldToNumber(form.get('missingAmountOrder')),
  missingTotal: fieldToNumber(form.get('missingTotal')),
  missingAmountOrderTotal: fieldToNumber(form.get('missingAmountOrderTotal')),
  flagLocTimeChk: Boolean(form.get('flagLocTimeChk')),
  flagEffectsChk: Boolean(form.get('flagEffectsChk')),
  flagMaxRunupChk: Boolean(form.get('flagMaxRunupChk')),
  flagAllRunupsEnteredChk: Boolean(form.get('flagAllRunupsEnteredChk')),
  flagAllRunupsSocioChk: Boolean(form.get('flagAllRunupsSocioChk')),
  housesDamaged: fieldToNumber(form.get('housesDamaged')),
  housesDamagedAmountOrder: fieldToNumber(form.get('housesDamagedAmountOrder')),
  housesDamagedTotal: fieldToNumber(form.get('housesDamagedTotal')),
  housesDamagedAmountOrderTotal: fieldToNumber(form.get('housesDamagedAmountOrderTotal')),
  eqDepth: fieldToNumber(form.get('eqDepth')),
  eqMagUnk: fieldToNumber(form.get('eqMagUnk')),
  eqMagMb: fieldToNumber(form.get('eqMagMb')),
  eqMagMs: fieldToNumber(form.get('eqMagMs')),
  eqMagMw: fieldToNumber(form.get('eqMagMw')),
  eqMagMl: fieldToNumber(form.get('eqMagMl')),
  eqMagMfa: fieldToNumber(form.get('eqMagMfa')),
  earthquakeEventId: fieldToNumber(form.get('earthquakeEventId')),
  volcanoEventId: fieldToNumber(form.get('volcanoEventId')),
  referenceIds: fromJS(form.get('referenceIds')).map(fieldToNumber).filter(value => value != null),
  publish: Boolean(form.get('publish')),
  oceanicTsunami: Boolean(form.get('oceanicTsunami')),
});
